import apiClient from './api';

const eventService = {
    // Alle Events abrufen
    getAllEvents: async () => {
        const response = await apiClient.get('/events');
        return response.data;
    },

    // Event nach ID abrufen
    getEventById: async (id) => {
        const response = await apiClient.get(`/events/${id}`);
        return response.data;
    },

    // Events einer Unit abrufen
    getEventsByUnit: async (unitId) => {
        const response = await apiClient.get(`/events/unit/${unitId}`);
        return response.data;
    },

    // Neues Event erstellen
    createEvent: async (eventData) => {
        const response = await apiClient.post('/events', eventData);
        return response.data;
    },

    // Event aktualisieren
    updateEvent: async (id, eventData) => {
        const response = await apiClient.put(`/events/${id}`, eventData);
        return response.data;
    },

    // Event löschen
    deleteEvent: async (id) => {
        const response = await apiClient.delete(`/events/${id}`);
        return response.data;
    },

    // Teilnehmer-Status aktualisieren
    updateParticipantStatus: async (participantId, statusData) => {
        const response = await apiClient.put(`/events/participants/${participantId}/status`, statusData);
        return response.data;
    },
};

export default eventService;

